import { lazy, Suspense } from 'react';
import { Capacitor } from '@capacitor/core';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Landing from './pages/Landing';
import MapSmokeTest from './dev/MapSmokeTest';
import Start from './pages/Start';
import AccountRecovery from './components/AccountRecovery';

const AuthenticatedApp = lazy(() => import('./AuthenticatedApp'));
const Legal = lazy(() => import('./pages/Legal'));

function AppLoading() {
  return <main className="loading-screen"><div className="route-loader"><span /></div><span>Tragenda</span></main>;
}

function LandingRoute() {
  const { user, profile, loading, authError, emailVerificationRequired } = useAuth();
  if (loading || authError || (user && !emailVerificationRequired && profile?.uid !== user.uid)) return <AccountRecovery />;
  if (emailVerificationRequired) return <Navigate to="/login" replace />;
  if (user && profile) return <Navigate to="/app/home" replace />;
  if (Capacitor.isNativePlatform()) return <Navigate to="/start" replace />;
  return <Landing />;
}

export default function App() {
  if (import.meta.env.VITE_MAP_SMOKE_TEST === 'true') return <MapSmokeTest />;

  return (
    <Suspense fallback={<AppLoading />}><Routes>
      <Route path="/" element={<LandingRoute />} />
      <Route path="/start" element={<Start />} />
      <Route path="/privacy" element={<Legal kind="privacy" />} />
      <Route path="/terms" element={<Legal kind="terms" />} />
      <Route path="/terms-and-conditions" element={<Legal kind="terms" />} />
      <Route path="/fair-use" element={<Legal kind="fairUse" />} />
      <Route path="/cookies" element={<Legal kind="cookies" />} />
      <Route path="/data-rights" element={<Legal kind="dataRights" />} />
      <Route path="/kvkk" element={<Legal kind="kvkk" />} />
      <Route path="/support" element={<Legal kind="support" />} />
      <Route path="/*" element={<Suspense fallback={<AppLoading />}><AuthenticatedApp /></Suspense>} />
    </Routes></Suspense>
  );
}
